/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
'use client';
import { ChevronDoubleRightIcon } from '@heroicons/react/16/solid';
import { ChevronDoubleLeftIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';
import React, { FC, useEffect, useState } from 'react';

import { ISideBarProps } from 'model/interfaces/header';

import Icons from 'components/typed-icons';
import { ODSModal } from 'kfone-component-library';
import { ButtonTheme } from 'kfone-component-library/enums';
import { useTranslation } from 'react-i18next';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { useCreateReportStore, useFileStore, useReportStatusStore } from 'store';
import useCountryStore from 'store/CountryStore';
import useNewReportStore from 'store/NewReport';
import './header.css';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const SideBar: FC<ISideBarProps> = (props = { show: false, toggle: () => { } }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const goToPage = (url: string) => {
    navigate(url);
  };
  const closeSidenavAndNavigate = (url: string) => {
    setTimeout(() => navigate(url), 400);
  };
  const [activeMenu, setActiveMenu] = useState(1);
  const isReportGenerateActive = useMatch('/payequity/generate-report/*');
  const { resetCountryStore } = useCountryStore();
  const { resetSelectedCategory, resetFileUpload } = useFileStore();
  const { updateActivationStepsStore, resetReportStore, updateActivatedSubStepsStore } =
    useNewReportStore();
  const { resetStore } = useCreateReportStore();
  const { setRenderNextStep } = useReportStatusStore();

  const handleClickStartNewReport = () => {
    closeSidenavAndNavigate('/payequity/generate-report');
    resetCountryStore();
    resetSelectedCategory();
    resetFileUpload();
    setActiveMenu(2);
    updateActivationStepsStore(1);
    updateActivatedSubStepsStore(0);
    resetReportStore();
    setRenderNextStep(false);
    resetStore();
  };
  useEffect(() => {
    if (isReportGenerateActive) {
      setActiveMenu(2);
    } else {
      resetCountryStore();
      resetSelectedCategory();
      resetFileUpload();
    }
  }, [isReportGenerateActive]);

  useEffect(() => {
    switch (location?.pathname) {
      case '/payequity':
        setActiveMenu(1);
        break;
      case '/payequity/generate-report':
        setActiveMenu(2);
        break;
      case '/payequity/saved-reports':
        setActiveMenu(3);
        break;
      case '/payequity/settings':
        setActiveMenu(4);
        break;
    }
  }, [location]);

  const handleToggle = () => {
    try {
      props.toggle();
    } catch (error) {
      console.error('Toggle errorr:', error);
    }
  };

  const menuOptions = (expanded = false, _width = '20px', _height = '20px') => {
    // eslint-disable-next-line react-hooks/rules-of-hooks

    return (
      <div
        className={`flex h-[100%] flex-col items-${expanded ? 'start px-[12px]' : 'center'} justify-between gap-[24px]`}
      >
        <div className={`flex flex-col items-${expanded ? 'start' : 'center'} gap-[24px]`}>
          <a onClick={handleToggle} className='flex gap-[8px]'>
            {expanded ? (
              <ChevronDoubleLeftIcon
                aria-hidden='true'
                className='h-[24px] w-[24px] text-[#186855]'
              />
            ) : (
              <ChevronDoubleRightIcon
                aria-hidden='true'
                className='h-[24px] w-[24px] text-[#186855]'
              />
            )}
            {expanded && <span>{t('pe.collapse')}</span>}
          </a>

          <div
            onClick={() => {
              if (expanded) props.toggle();
              closeSidenavAndNavigate('/payequity');
              setActiveMenu(1);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 1 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            {/* <HomeIcon
              aria-hidden='true'
              className={`h-[${expanded ? '24px' : '20px'}] w-[${expanded ? '24px' : '20px'}]`}
            /> */}
            <img
              alt='React Logo'
              className={`h-[${_height}] w-[${_width}] common-icon`}
              src={typeof Icons.HomeIcon === 'string' ? Icons.HomeIcon : ''}
            />
            {expanded && <span>{t('pe.payEquityHome')}</span>}
          </div>

          <div
            onClick={() => {
              if (expanded) props.toggle();
              handleClickStartNewReport();
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 2 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            {/* <FolderPlusIcon className={`h-[${_height}] w-[${_width}]`} /> */}
            <img
              alt='React Logo'
              className={`h-[${_height}] w-[${_width}] custom-image`}
              src={typeof Icons.MyTasks === 'string' ? Icons.MyTasks : ''}
            />
            {expanded && <span>{t('pe.startNewReport')}</span>}
          </div>

          <div
            onClick={() => {
              if (expanded) props.toggle();
              closeSidenavAndNavigate('/payequity/saved-reports');
              setActiveMenu(3);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 3 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            <img
              src={Icons.MySavedReportIcon as string}
              alt='saved report'
              // aria-hidden='true'
              className={`h-[${expanded ? '26px' : _height + 6}] w-[${expanded ? '26px' : _width + 6}] .common-icon`}
            />
            {expanded && <span>{t('pe.mySavedReports')}</span>}
          </div>
        </div>
        <div
          className={`flex flex-col items-${expanded ? 'start gap-[16px]' : 'center gap-[16px]'} `}
        >
          {expanded && <div className='tools-label'>{t('pe.tools')}</div>}
          <div className='divider'>
            {/* <Cog6ToothIcon aria-hidden='true' className={`h-[${_height}] w-[${_width}]`}  /> */}
          </div>
          <div
            onClick={() => {
              if (expanded) props.toggle();
              closeSidenavAndNavigate('/payequity/settings');
              setActiveMenu(4);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 4 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            <Cog6ToothIcon aria-hidden='true' className={`h-[${_height}] w-[${_width}]`} />
            {expanded && <span>{t('pe.settings')}</span>}
          </div>
          {/* currently removing helpCenter */}
          {/*<div
            onClick={() => {
              if (expanded) props.toggle();
              setActiveMenu(5);
            }}
            className={`sidemenu-icon flex gap-[8px] ${activeMenu == 5 && (!expanded ? 'active-menu' : 'active-menu-exapnded')}`}
          >
            <QuestionMarkCircleIcon className={`h-[${_height}] w-[${_width}]`} />
            {expanded && <span>{t('pe.helpCenter')}</span>}
          </div>*/}
        </div>
      </div>
    );
  };
  return (
    <>
      <div className='app-sidemenu fixed inset-y-0 bottom-12 left-0 top-[64px] z-[10] flex w-[64px] flex-col bg-[#fff] p-[16px]'>
        {menuOptions()}
      </div>
      {props.show && (
        <ODSModal
          isOpen={true}
          onClose={() => {
            props.toggle();
          }}
          id='sidebar-modal'
          className='sidebar-modal'
          bodyContent={
            <div className='report-modal-content relative mb-4'>
              <div className='fixed inset-0 overflow-hidden'>
                <div
                  className='sidemenu-overlay-block'
                  onClick={() => {
                    props.toggle();
                  }}
                ></div>

                <div className=''>
                  <div className='pointer-events-none fixed inset-y-0 left-0 top-[48px] flex max-w-full pl-0'>
                    <div className='pointer-events-auto relative w-screen max-w-[264px] data-[closed]:-translate-x-full'>
                      <div className='expanded-view flex h-full flex-col overflow-hidden bg-white py-6 pb-[0] shadow-xl'>
                        {menuOptions(true)}
                        <div className='relative mt-6 flex-1 px-4 sm:px-6'></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      )}

      {/* <Dialog
        open={props?.show}
        onClose={() => {
          props.toggle();
        }}
        className='relative z-10'
      >
        <DialogBackdrop
          transition
          className='fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0'
        />

        <div className='fixed inset-0 overflow-hidden'>
          <div className='absolute inset-0 overflow-hidden'>
            <div className='pointer-events-none fixed inset-y-0 left-0 top-[48px] flex max-w-full pl-0'>
              <DialogPanel
                transition
                className='pointer-events-auto relative w-screen max-w-[264px] transform transition duration-500 ease-in-out data-[closed]:-translate-x-full sm:duration-700'
              >
                <div className='expanded-view flex h-full flex-col overflow-hidden bg-white py-6 pb-[0] shadow-xl'>
                  {menuOptions(true)}
                  <div className='relative mt-6 flex-1 px-4 sm:px-6'></div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog> */}
    </>
  );
};
